import React, { useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import {
  CustomCardColorBar,
  CustomDropdown,
  CustomPanel,
  PageHeader,
  Periodo,
  SectionTitle,
} from '../../../../components'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../assets/js/styles'
import usePainelInsumo, { ACTION } from './PainelInsumoHook'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import { azul, azul_escuro, laranja, pink, vinho } from '../../../../assets/js/colors'

function PainelInsumo({ history, dispatch, selectedTp }) {
  const { state, localDispatch } = usePainelInsumo()

  useEffect(() => {
    if (selectedTp) localDispatch.setAction(ACTION.INITIAL_FETCH)
  }, [selectedTp])

  useEffect(() => {
    switch (state.action) {
      case ACTION.IDLE:
        dispatch(hideLoadingBox())
        break
      case ACTION.INITIAL_FETCH:
        dispatch(showLoadingBox(ACTION.INITIAL_FETCH, 'Aguarde:'))
        localDispatch.getPainelInsumoInitialInfo(selectedTp)
        break
      case ACTION.GET_PAINEL_DATA:
        dispatch(showLoadingBox(ACTION.GET_PAINEL_DATA, 'Aguarde:'))
        localDispatch.getPainelInsumoData(
          state.pInicial,
          state.pFinal,
          state.insumoSelecionado,
          selectedTp,
        )
        break
      default:
        break
    }
  }, [state.action])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  // Render
  return (
    <>
      <PageHeader>7.3 - Painel Insumo</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel showBtnNovo={false} onVoltar={history.goBack}>
          <div className="p-grid">
            <div className="p-col-12">
              <SectionTitle title={'Selecione as Informações abaixo'} />
            </div>
            <div className="p-col-4">
              <Periodo
                periodoInicial={state.pInicial}
                periodoFinal={state.pFinal}
                onPesquisar={localDispatch.onBtnPeriodoClick}
              />
            </div>
            <div className="p-col-4">
              <CustomDropdown
                label={'Selecione o Insumo:'}
                options={state.insumos}
                onChange={localDispatch.onInsumoChange}
                value={state.insumoSelecionado}
                optionLabel={'name'}
              />
            </div>
            <div className="p-col-12">
              <SectionTitle title={'Indicadores'} />
            </div>
            <div className="p-col-4">
              <CustomCardColorBar
                value={state.qteEntrada}
                title={'Qte Entrada'}
                subTitle={`em ${state.unidadeMovimentacao}`}
                barColor={azul}
              />
            </div>
            <div className="p-col-4">
              <CustomCardColorBar
                value={state.qteSaida}
                title={'Qte Saída'}
                subTitle={`em ${state.unidadeMovimentacao}`}
                barColor={vinho}
              />
            </div>
            <div className="p-col-4">
              <CustomCardColorBar
                value={state.qteDisponivel}
                title={'Qte Disponível'}
                subTitle={`em ${state.unidadeMovimentacao}`}
                barColor={laranja}
              />
            </div>
            <div className="p-col-4">
              <CustomCardColorBar
                value={state.qtePorTon}
                title={'Qte Por Tonelada'}
                subTitle={`qte/ton`}
                barColor={azul_escuro}
              />
            </div>
            <div className="p-col-4">
              <CustomCardColorBar
                value={state.qtePorCx}
                title={'Qte Por Caixa'}
                subTitle={`qte/cx`}
                barColor={pink}
              />
            </div>
            {state.rankingConsumoInsumo.length !== 0 ? (
              <>
                <div className="p-col-12">
                  <SectionTitle title={'Ranking'} />
                </div>
                <div className="p-col-12">
                  <DataTable
                    value={state.rankingConsumoInsumo}
                    emptyMessage={'Nenhuma informação disponível'}
                  >
                    <Column field={'tp_name'} header={'Operação Logística'} />
                    <Column
                      field={'qte_entrada'}
                      header={'Qte Entrada'}
                      style={tableCellCentered(150)}
                    />
                    <Column
                      field={'qte_saida'}
                      header={'Qte Saída'}
                      style={tableCellCentered(150)}
                    />
                    <Column
                      field={'qte_disponivel'}
                      header={'Qte Disponível'}
                      style={tableCellCentered(150)}
                    />
                    <Column
                      field={'qte_por_ton'}
                      header={'Qte/Ton'}
                      style={tableCellCentered(150)}
                    />
                    <Column field={'qte_por_cx'} header={'Qte/Cx'} style={tableCellCentered(150)} />
                  </DataTable>
                </div>
              </>
            ) : null}
          </div>
        </CustomPanel>
      </div>
    </>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(PainelInsumo))
